// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SM5btXX9PThtBAIGrMwh {
  min-height: 100vh;
  overflow: hidden;
}

.mAWvjGRT2n9ovP3oYZgs {
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(240 240 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0px;
  padding-bottom: 0px;
}

.kOiItSSM_tbOT896YuB3 {
  margin: auto;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
  height: 35px;
  width: 100%;
}

.eQmI3bUEesYeSeUUSLME {
  margin-left: 1rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-color: none;
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.iusRPwBwbwQgzogPxmoU {
  height: calc(100vh - 84px);
}

.yb57DEYDo3EuCoWrxBjb {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.khwvOlVZMg7AvxIvVbrm {
  flex: 1 1 0%;
  overflow: auto;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  border-right-width: 0px;
  scrollbar-width: thin;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.yb57DEYDo3EuCoWrxBjb::-webkit-scrollbar {
  display: none;
  width: 0px;
}
.khwvOlVZMg7AvxIvVbrm::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgba(0,0,0,0.15);
}

.TCGEoTSC8c6FiNiIWDJN .ant-menu-item {
  margin-left: 1rem;
  width: calc(100% - 40px);
  border-radius: 5px;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.TCGEoTSC8c6FiNiIWDJN .ant-menu-submenu {
  margin-left: 1.25rem;
  width: calc(100% - 40px);
}

.GPDevco9jYHpKgeWgBCK {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  overflow: hidden;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.wQME9ob4GZ3V4OgyIV_L {
  min-height: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 5px;
}

.noTIHybFTLa8s7ASt8GQ {
  position: absolute;
  right: -10px;
  top: 1rem;
  z-index: 1000000;
  height: 20px;
  width: 20px;
  cursor: pointer;
  border-radius: 50%;
  border-color: none;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 7px;
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
  transition-property: background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  box-shadow: 0 0.5px 2px black;
}

.noTIHybFTLa8s7ASt8GQ:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}

.SooV2m5kTNYzJUP3vWGn {
  display: flex;
  align-items: center;
}

.LOHXhrhUpcQgLzCJap_Z {
  margin-right: 1.5rem;
  display: flex;
  height: 38px;
  width: 131px;
  align-items: center;
  border-radius: 50px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(231 231 231 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity, 1));
}

.aGIUWElIkbDfPgnlY827 {
  margin-left: 5px;
  display: flex;
  height: 1.75rem;
  width: 1.75rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  -o-object-fit: contain;
     object-fit: contain;
}

.EM4uW0xJQ6c4WgGoh_uA {
  width: 45%;
  height: auto;
}

.AJSLhxDXM9q4thg3hEXm {
  margin-left: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1));
}

.akrucbvNM33ozbIXFTjS {
  margin-left: -2px;
}

.ne37S6vbH95l7Vv7VRK6 {
  position: absolute;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(47 47 47 / var(--tw-bg-opacity, 1));
  text-align: center;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));

  top: -5px;
  right: -5px;
  padding: 0 2.5px;
  font: 600 10px/18px system-ui;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.dVyDI3GJP5XWK4_indck {
  margin-left: 0.75rem;
  display: flex;
  height: 2.75rem;
  width: 2.75rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.jTX10sjgGbm8eeQ8CIgQ {
  margin-left: 1rem;
  margin-right: 0.5rem;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.jTX10sjgGbm8eeQ8CIgQ > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.f8DZAAVT1UeD2vUYJjSg {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.IZPgFRi1z56Qs6MEQYTp {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.AmoyvGKa9glnCTm0fYSt {
  height: 14px !important;
  min-height: 14px !important;
  width: 14px !important;
  min-width: 14px !important;
}

._9N_Pvj6x30bs1HJIEPfa {
  height: 10px !important;
  min-height: 10px !important;
  width: 10px !important;
  min-width: 10px !important;
}

.sf7vBlkOrzCIIJwbO8zS {
  width: 10px;
  height: 10px;
  display: inline-block;
  background: no-repeat center / contain;
  background-image: var(--icon-inactive);
}

.ant-menu-submenu-inline.ant-menu-submenu-open > .ant-menu-submenu-title .sf7vBlkOrzCIIJwbO8zS {
  background-image: var(--icon-active);
}

.ant-menu-submenu-inline:not(.ant-menu-submenu-open):not(.ant-menu-submenu-selected)
      > .ant-menu-submenu-title:hover
  .sf7vBlkOrzCIIJwbO8zS {
  background-image: var(--icon-hover);
}

.qD7oPjOApaqaXZPWrFIp {
  display: flex;
  width: 150px;
  flex-direction: column;
}

.F_oiHtIxGQgnjOxcIdpd {
  height: 38px;
}

.PacdHxxCqM4a56zHG205 {
  margin-left: 0.75rem;
  text-align: center;
}

.ZEN1mcPoLjzfFr4AIQwC {
  position: absolute;
  bottom: 1.25rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  background-color: transparent;
  padding: 0.625rem;
}

.z7QjBgvUCkkn0CrGL48b {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 9999px;
}

.KBTQ4o9MNdilEGJBWlhY {
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-size: 14px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.SRIiK1Dd0SOfYHHqF0gA {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  overflow: hidden;
  --tw-bg-opacity: 1;
  background-color: rgb(243 202 202 / var(--tw-bg-opacity, 1));
}

.OJVr0GYMAYDA2h722aRX {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
}
.nqpjMeQUQj53nuXbwsI2 {
  display: flex;
  height: 100%;
  align-items: center;
  white-space: nowrap;
  padding-left: 1rem;
  padding-right: 1rem;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.GUiiyLhWXCuIy7H0THhU {
  margin-top: 40px;
}

.TfUCUAxQgtLUS9tHtpXG {
  display: flex;
  height: 30px;
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1)) !important;
  padding-top: 0px;
  padding-bottom: 0px;
}

.WqpQaVri5W_BfLOFJ3YX {
  font-size: 11px;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivateLayout/PrivateLayout.module.css"],"names":[],"mappings":"AACE;EAAA,iBAAmC;EAAnC;AAAmC;;AAInC;EAAA,aAA4G;EAA5G,YAA4G;EAA5G,mBAA4G;EAA5G,8BAA4G;EAA5G,wBAA4G;EAA5G,mBAA4G;EAA5G,sBAA4G;EAA5G,mEAA4G;EAA5G,kBAA4G;EAA5G,4DAA4G;EAA5G,oBAA4G;EAA5G,qBAA4G;EAA5G,gBAA4G;EAA5G;AAA4G;;AAI5G;EAAA,YAAuC;EAAvC,kBAAuC;EAAvC,mBAAuC;EAAvC,YAAuC;EAAvC;AAAuC;;AAIvC;EAAA,iBAAgF;EAAhF,eAAgF;EAAhF,sBAAgF;EAAhF,kBAAgF;EAAhF,kBAAgF;EAAhF,0DAAgF;EAAhF,qBAAgF;EAAhF,sBAAgF;EAAhF,oBAAgF;EAAhF,uBAAgF;EAAhF,oBAAgF;EAAhF;AAAgF;;AAIhF;EAAA;AAA6B;;AAI7B;EAAA,aAAoB;EAApB,sBAAoB;EACpB,kBAAyC;EAAzC,iBAAyC;EAAzC,kBAAyC;EAAzC;AADoB;AAIpB;EAAA,YAA6D;EAA7D,cAA6D;EAA7D,gBAA6D;EAA7D,kBAA6D;EAC7D,YAAwB;EAAxB,uBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB;AAJ6D;AAO7D;EAAA,aAAiB;EAAjB;AAAiB;AAGjB;EAAA,kBAA0C;EAA1C;AAA0C;;AAI1C;EAAA,iBAAqD;EAArD,wBAAqD;EAArD,kBAAqD;EAArD,6BAAqD;EAArD;AAAqD;;AAIrD;EAAA,oBAAiC;EAAjC;AAAiC;;AAIjC;EAAA,aAAqD;EAArD,YAAqD;EAArD,sBAAqD;EAArD,gBAAqD;EAArD,oBAAqD;EAArD,qBAAqD;EAArD,mBAAqD;EAArD;AAAqD;;AAIrD;EAAA,eAA8D;EAA9D,gBAA8D;EAA9D,kBAA8D;EAA9D;AAA8D;;AAI9D;EAAA,kBAAgM;EAAhM,YAAgM;EAAhM,SAAgM;EAAhM,gBAAgM;EAAhM,YAAgM;EAAhM,WAAgM;EAAhM,eAAgM;EAAhM,kBAAgM;EAAhM,kBAAgM;EAAhM,kBAAgM;EAAhM,4DAAgM;EAAhM,iBAAgM;EAAhM,oBAAgM;EAAhM,mDAAgM;EAAhM,+BAAgM;EAAhM,wDAAgM;EAAhM,0BAAgM;EAAhM,yBAAgM;EAAhM,gCAAgM;EAChM;AADgM;;AAKhM;EAAA,kBAAkB;EAAlB;AAAkB;;AAIlB;EAAA,aAAwB;EAAxB;AAAwB;;AAIxB;EAAA,oBAAkG;EAAlG,aAAkG;EAAlG,YAAkG;EAAlG,YAAkG;EAAlG,mBAAkG;EAAlG,mBAAkG;EAAlG,iBAAkG;EAAlG,sBAAkG;EAAlG,4DAAkG;EAAlG,kBAAkG;EAAlG;AAAkG;;AAIlG;EAAA,gBAA8E;EAA9E,aAA8E;EAA9E,eAA8E;EAA9E,cAA8E;EAA9E,mBAA8E;EAA9E,uBAA8E;EAA9E,qBAA8E;EAA9E,kBAA8E;EAA9E,4DAA8E;EAC9E,sBAAmB;KAAnB;AAD8E;;AAIhF;EACE,UAAU;EACV,YAAY;AACd;;AAGE;EAAA,oBAAiC;EAAjC,mBAAiC;EAAjC,oBAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;;AAGnC;EACE,iBAAiB;AACnB;;AAGE;EAAA,kBAAuE;EAAvE,eAAuE;EAAvE,cAAuE;EAAvE,qBAAuE;EAAvE,kBAAuE;EAAvE,yDAAuE;EAAvE,kBAAuE;EAAvE,oBAAuE;EAAvE,mDAAuE;;EAEvE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B;AANuE;;AAUvE;EAAA,oBAA8G;EAA9G,aAA8G;EAA9G,eAA8G;EAA9G,cAA8G;EAA9G,mBAA8G;EAA9G,uBAA8G;EAA9G,kBAA8G;EAA9G,kBAA8G;EAA9G,0DAA8G;EAA9G,mBAA8G;EAA9G,oBAA8G;EAA9G,yBAA8G;EAA9G,oBAA8G;EAA9G;AAA8G;;AAI9G;EAAA,iBAA2D;EAA3D,oBAA2D;EAA3D,aAA2D;EAA3D,eAA2D;EAA3D;AAA2D;;AAA3D;EAAA,uBAA2D;EAA3D,sDAA2D;EAA3D;AAA2D;;AAI3D;EAAA,8BAAuD;EAAvD,wDAAuD;EAAvD,0BAAuD;EAAvD,yBAAuD;EAAvD;AAAuD;;AAIvD;EAAA,mBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,uBAAsD;EAAtD,2BAAsD;EAAtD,sBAAsD;EAAtD;AAAsD;;AAItD;EAAA,uBAAsD;EAAtD,2BAAsD;EAAtD,sBAAsD;EAAtD;AAAsD;;AAGxD;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAKE,mCAAmC;AACrC;;AAGE;EAAA,aAA8B;EAA9B,YAA8B;EAA9B;AAA8B;;AAI9B;EAAA;AAAe;;AAIf;EAAA,oBAAuB;EAAvB;AAAuB;;AAIvB;EAAA,kBAA6F;EAA7F,eAA6F;EAA7F,aAA6F;EAA7F,WAA6F;EAA7F,mBAA6F;EAA7F,uBAA6F;EAA7F,aAA6F;EAA7F,6BAA6F;EAA7F;AAA6F;;AAI7F;EAAA,eAA2B;EAA3B,cAA2B;EAA3B;AAA2B;;AAI3B;EAAA,sBAA6E;EAA7E,mBAA6E;EAA7E,oBAA6E;EAA7E,eAA6E;EAA7E,gBAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;;AAI7E;EAAA,eAAkG;EAAlG,QAAkG;EAAlG,SAAkG;EAAlG,YAAkG;EAAlG,aAAkG;EAAlG,YAAkG;EAAlG,WAAkG;EAAlG,mBAAkG;EAAlG,gBAAkG;EAAlG,kBAAkG;EAAlG;AAAkG;;AAIlG;EAAA,kBAA+C;EAA/C,aAA+C;EAA/C,YAA+C;EAA/C,WAA+C;EAA/C;AAA+C;AAG/C;EAAA,aAAmH;EAAnH,YAAmH;EAAnH,mBAAmH;EAAnH,mBAAmH;EAAnH,kBAAmH;EAAnH,mBAAmH;EAAnH,sBAAmH;EAAnH,eAAmH;EAAnH,gBAAmH;EAAnH,oBAAmH;EAAnH;AAAmH;;AAInH;EAAA;AAAgB;;AAIhB;EAAA,aAAwF;EAAxF,YAAwF;EAAxF,WAAwF;EAAxF,cAAwF;EAAxF,mBAAwF;EAAxF,uBAAwF;EAAxF,6BAAwF;EAAxF,uEAAwF;EAAxF,gBAAwF;EAAxF;AAAwF;;AAIxF;EAAA,eAAiC;EAAjC,oBAAiC;EAAjC;AAAiC","sourcesContent":[".layoutRoot {\n  @apply min-h-screen overflow-hidden;\n}\n\n.header {\n  @apply flex items-center justify-between h-[70px] px-6 py-0 border-b-gray-800 border-b border-solid bg-white;\n}\n\n.appTitle {\n  @apply w-full h-[35px] m-auto mt-6 mb-8;\n}\n\n.logoutButton {\n  @apply text-white rounded cursor-pointer ml-4 px-3 py-1 border-[none] bg-primary;\n}\n\n.bodyLayout {\n  @apply h-[calc(100vh_-_84px)];\n}\n\n.sider {\n  @apply flex flex-col;\n  @apply bg-white relative overflow-visible;\n}\n.menu {\n  @apply flex-1 overflow-y-auto overflow-x-hidden overflow-auto;\n  @apply h-full border-r-0;\n  scrollbar-width: thin;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.sider::-webkit-scrollbar {\n  @apply w-0 hidden;\n}\n.menu::-webkit-scrollbar-thumb {\n  @apply bg-[rgba(0,0,0,0.15)] rounded-[3px];\n}\n\n.expanedMenu :global(.ant-menu-item) {\n  @apply w-[calc(100%_-_40px)] ml-4 !px-4 rounded-[5px];\n}\n\n.expanedMenu :global(.ant-menu-submenu) {\n  @apply w-[calc(100%_-_40px)] ml-5;\n}\n\n.innerLayout {\n  @apply overflow-hidden px-6 py-6 flex flex-col flex-1;\n}\n\n.content {\n  @apply min-h-0 overflow-y-auto overflow-x-hidden rounded-[5px];\n}\n\n.collapseButton {\n  @apply absolute text-gray-300 bg-white pl-[7px] h-[20px] w-[20px] cursor-pointer z-[1000000] transition-[background] duration-[0.3s] ease-[ease] rounded-[50%] border-[none] -right-[10px] top-4;\n  box-shadow: 0 0.5px 2px black;\n}\n\n.collapseButton:hover {\n  @apply bg-gray-100;\n}\n\n.headerLeftContainer {\n  @apply flex items-center;\n}\n\n.companyInfo {\n  @apply w-[131px] h-[38px] bg-gray-800 border border-gray-900 mr-6 rounded-[50px] flex items-center;\n}\n\n.companyBuildingIconWrapper {\n  @apply h-7 w-7 bg-white rounded-full ml-[5px] flex items-center justify-center;\n  object-fit: contain;\n}\n\n.companyBuildingIcon {\n  width: 45%;\n  height: auto;\n}\n\n.companyName {\n  @apply ml-3 text-gray-400 text-sm;\n}\n\n.notificationBellIcon {\n  margin-left: -2px;\n}\n\n.notificationCount {\n  @apply absolute w-5 h-5 rounded-full bg-gray-500 text-white text-center;\n\n  top: -5px;\n  right: -5px;\n  padding: 0 2.5px;\n  font: 600 10px/18px system-ui;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.avatar {\n  @apply bg-primary text-[white] text-sm w-11 h-11 ml-3 flex items-center justify-center uppercase rounded-[50%];\n}\n\n.avatarWrapper {\n  @apply flex items-center space-x-2 ml-4 mr-2 cursor-pointer;\n}\n\n.icon {\n  @apply transition-transform duration-[0.3s] ease-[ease];\n}\n\n.rotated {\n  @apply rotate-180;\n}\n\n.menuItem {\n  @apply !min-w-[14px] !min-h-[14px] !w-[14px] !h-[14px];\n}\n\n.menuExpandIcon {\n  @apply !min-w-[10px] !min-h-[10px] !w-[10px] !h-[10px];\n}\n\n.expandIcon {\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n  background: no-repeat center / contain;\n  background-image: var(--icon-inactive);\n}\n\n:global(.ant-menu-submenu-inline.ant-menu-submenu-open > .ant-menu-submenu-title) .expandIcon {\n  background-image: var(--icon-active);\n}\n\n:global(\n    .ant-menu-submenu-inline:not(.ant-menu-submenu-open):not(.ant-menu-submenu-selected)\n      > .ant-menu-submenu-title:hover\n  )\n  .expandIcon {\n  background-image: var(--icon-hover);\n}\n\n.popoverContainer {\n  @apply flex flex-col w-[150px];\n}\n\n.popoverBtn {\n  @apply h-[38px];\n}\n\n.logoWrapper {\n  @apply ml-3 text-center;\n}\n\n.profileWrapper {\n  @apply absolute bottom-5 w-full flex items-center justify-center p-2.5 gap-2.5 bg-transparent;\n}\n\n.profileImage {\n  @apply w-9 h-9 rounded-full;\n}\n\n.profileName {\n  @apply text-sm text-gray-500 font-inter text-dashboardMain font-dashboardMain;\n}\n\n.alertContainer {\n  @apply h-[40px] fixed top-0 left-0 w-full  bg-danger-200 z-[999] overflow-hidden flex items-center;\n}\n\n.alertDiv {\n  @apply relative w-full h-full flex items-center;\n}\n.alertText {\n  @apply whitespace-nowrap text-red-800 font-dashboardMain text-dashboardSub font-inter px-4 flex items-center h-full;\n}\n\n.topHeight {\n  @apply mt-[40px];\n}\n\n.footer {\n  @apply w-full flex items-center flex-shrink-0 justify-center h-[30px] py-0 !bg-[#f1f5f9];\n}\n\n.footerText {\n  @apply text-slate-600 text-[11px];\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutRoot": `SM5btXX9PThtBAIGrMwh`,
	"header": `mAWvjGRT2n9ovP3oYZgs`,
	"appTitle": `kOiItSSM_tbOT896YuB3`,
	"logoutButton": `eQmI3bUEesYeSeUUSLME`,
	"bodyLayout": `iusRPwBwbwQgzogPxmoU`,
	"sider": `yb57DEYDo3EuCoWrxBjb`,
	"menu": `khwvOlVZMg7AvxIvVbrm`,
	"expanedMenu": `TCGEoTSC8c6FiNiIWDJN`,
	"innerLayout": `GPDevco9jYHpKgeWgBCK`,
	"content": `wQME9ob4GZ3V4OgyIV_L`,
	"collapseButton": `noTIHybFTLa8s7ASt8GQ`,
	"headerLeftContainer": `SooV2m5kTNYzJUP3vWGn`,
	"companyInfo": `LOHXhrhUpcQgLzCJap_Z`,
	"companyBuildingIconWrapper": `aGIUWElIkbDfPgnlY827`,
	"companyBuildingIcon": `EM4uW0xJQ6c4WgGoh_uA`,
	"companyName": `AJSLhxDXM9q4thg3hEXm`,
	"notificationBellIcon": `akrucbvNM33ozbIXFTjS`,
	"notificationCount": `ne37S6vbH95l7Vv7VRK6`,
	"avatar": `dVyDI3GJP5XWK4_indck`,
	"avatarWrapper": `jTX10sjgGbm8eeQ8CIgQ`,
	"icon": `f8DZAAVT1UeD2vUYJjSg`,
	"rotated": `IZPgFRi1z56Qs6MEQYTp`,
	"menuItem": `AmoyvGKa9glnCTm0fYSt`,
	"menuExpandIcon": `_9N_Pvj6x30bs1HJIEPfa`,
	"expandIcon": `sf7vBlkOrzCIIJwbO8zS`,
	"popoverContainer": `qD7oPjOApaqaXZPWrFIp`,
	"popoverBtn": `F_oiHtIxGQgnjOxcIdpd`,
	"logoWrapper": `PacdHxxCqM4a56zHG205`,
	"profileWrapper": `ZEN1mcPoLjzfFr4AIQwC`,
	"profileImage": `z7QjBgvUCkkn0CrGL48b`,
	"profileName": `KBTQ4o9MNdilEGJBWlhY`,
	"alertContainer": `SRIiK1Dd0SOfYHHqF0gA`,
	"alertDiv": `OJVr0GYMAYDA2h722aRX`,
	"alertText": `nqpjMeQUQj53nuXbwsI2`,
	"topHeight": `GUiiyLhWXCuIy7H0THhU`,
	"footer": `TfUCUAxQgtLUS9tHtpXG`,
	"footerText": `WqpQaVri5W_BfLOFJ3YX`
};
export default ___CSS_LOADER_EXPORT___;
